import { createTheme } from "@mui/material";

export const colorAiDisabled = "#E6CEF5";
export const colorAiDarker = "#5C3080";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4A4A4A",
    },
    info: {
      main: "#ffffff",
    },
    ai: {
      main: "#B989ED",
      dark: "#8958BD",
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
          color: "currentColor",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderRadius: "6px",
          fontWeight: "bold",
        },
        contained: {
          "--tw-shadow": "0px 0px 15px rgba(0, 0, 0, 0.1)",
          "--tw-shadow-colored": "0px 0px 15px var(--tw-shadow-color)",
          "box-shadow":
            "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
          borderRadius: "6px",
          fontWeight: "bold",
        },
      },
    },
  },
});
